import logo from './assets/logo-color.svg';

export type LogoProps = {
  withAnchor?: boolean;
};

export const Logo = ({ withAnchor = false }: LogoProps): JSX.Element => {
  if (withAnchor) {
    return (
      <a href="/" data-testid="logoAnchor">
        <img src={logo} alt="creditas" />
      </a>
    );
  }

  return <img src={logo} alt="creditas" data-testid="logo" />;
};
